import React, { createContext, useContext, useState, useEffect } from 'react';
import { applyTheme, applyFont, getStoredTheme, getStoredFont } from '../themes/utils';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('light');
  const [font, setFont] = useState('Inter');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Initialize theme and font from localStorage
    const storedTheme = getStoredTheme();
    const storedFont = getStoredFont();
    
    setTheme(storedTheme);
    setFont(storedFont);
    
    // Apply theme and font
    applyTheme(storedTheme);
    applyFont(storedFont);
    
    setIsLoading(false);
  }, []);

  const updateTheme = (newTheme) => {
    setTheme(newTheme);
    applyTheme(newTheme);
  };

  const updateFont = (newFont) => {
    setFont(newFont);
    applyFont(newFont);
  };

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    updateTheme(newTheme);
  };

  if (isLoading) {
    return <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
    </div>;
  }

  return (
    <ThemeContext.Provider value={{
      theme,
      font,
      updateTheme,
      updateFont,
      toggleTheme,
      isDark: theme === 'dark'
    }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
